import type { UserOrigin } from "@/types";

// Mirrors ApplicationMailer::BRANDS.
const BRAND_EMAILS: Record<UserOrigin, string> = {
  los_tilos: "contacto@fundacionlostilos.com",
  la_cuesta: "contacto@retirosycursos.cl",
};

export function brandEmail(origin: UserOrigin | null | undefined): string {
  return BRAND_EMAILS[origin === "la_cuesta" ? "la_cuesta" : "los_tilos"];
}
